export const formatExpire = (value = '') => {
  let result = value;

  if (value.length === 1 && Number(value) > 1) result = `0${value}/`;
  if (value.length >= 2 && Number(value.substring(0, 2)) > 12) result = value.replace(value.substring(0, 2), '12');

  return result;
};
